const LOG_EVENTS = {
  INTRO: {
    introSentClaim: { element: 'intro-sent-claim', type: 'click' },
    transactionStatus: { element: '', type: '' },
    introSentManual: { element: 'intro-sent-manual', type: 'click' },
    introHowItWorks: { element: 'intro-how-it-works', type: 'click' },
    introPrivacyStatement: { element: 'intro-privacy-statement', type: 'click' },
    claimedTransactionRecord: { element: 'Claimed-transaction-record', type: 'click' },
    settledTransactionRecord: { element: 'Settled-transaction-record', type: 'click' },
    howItWorksClose: { element: 'How-it-works-close', type: 'click' },
    plaidClaim: { element: 'Plaid-claim', type: 'click' },
    manualEntryClaim: { element: 'Manual-entry-claim', type: 'click' },
    manualPrivacyStatement: { element: 'Manual-privacy-statement', type: 'click' },
  },
  VERIFICATION: {
    verificationSent: { element: 'Verify', type: 'click' },
    VerificationErrorBanner: { element: 'Verification-Error-Banner', type: 'click' },
    VerifyRetry: { element: 'Verify-Retry', type: 'click' },
    VerifyRetryFinal: { element: 'Verify-Retry-Final', type: 'click' },
    successTransactionRecord: { element: 'Success-transaction-record', type: 'click' },
    plaidSuccessSaveDetails: { element: 'Plaid-success-save-details', type: 'click' },
    PlaidSuccessClose: { element: 'Plaid-success-close', type: 'click' },
    PlaidSuccessPrivacyStatement: { element: 'Plaid-success-privacy-statement', type: 'click' },
    PlaidSuccessTerms: { element: 'Plaid-success-terms', type: 'click' },
    ClaimSuccessPrivacyStatement: { element: 'Claim-success-privacy-statement', type: 'click' },
  },
};

export default LOG_EVENTS;
